import * as analyticsdashboard from './js/analyticsdashboard.js'
var AnalyticsApi = {};

AnalyticsApi.install = function(Vue) {
  Vue.prototype.$analytic = analyticsdashboard;
}

export default AnalyticsApi
